module.exports = __webpack_public_path__ + "static/img/logo_short.4621ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/logo_short.png
// module id = TFpa
// module chunks = 1